import { defineComponent as _defineComponent } from 'vue'
import useCommonMixin from '@/composables/useCommonMixin'
  import { computed } from 'vue'
  import { UserModule } from '@/store/modules/user'
  import { CourseModule } from '@/store/modules/course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseExpiredBanner',
  setup(__props) {

  const { formatDate } = useCommonMixin()

  const expired = computed(() => CourseModule.course?.expired)

  const expiredAt = computed(() => CourseModule.course?.expiredAt ?? null)

  const expiryDuration = computed(() => UserModule.company?.courseExpiryDuration)

return { __sfc: true,formatDate, expired, expiredAt, expiryDuration, useCommonMixin, computed, UserModule, CourseModule }
}

})